import { env } from './env';

export const environment = {
  production: false,
  apiPath: '/api/',
  apiDomain: '',
  configuration: env?.configuration,
  facebookAppId: '',
  googleClientId: '',
  buildCheck: true,
};
